import React from "react";
import { getDayName, getTotal } from "../../../utils";
import { HistoryProject, SessionsDay, TimeTrackingSession } from "../../types";
import { HOURS_COLOR } from "./SessionsHistory";
import { SessionGroup } from "./SessionGroup";

const groupByDescription = (
  sessions: TimeTrackingSession[],
): TimeTrackingSession[][] => {
  const map = new Map<string, TimeTrackingSession[]>();
  for (const session of sessions) {
    const key = session.description?.trim() || "";
    if (!map.has(key)) map.set(key, []);
    map.get(key)!.push(session);
  }
  return Array.from(map.values());
};

interface DayProps {
  day: SessionsDay;
}

export const Day: React.FC<DayProps> = ({ day }) => {
  return (
    <div
      style={{
        margin: "8px",
        borderRadius: "12px",
        border: "2px solid",
        borderColor: "#cbd2f49f",
      }}
    >
      <div
        style={{
          backgroundColor: "#fafafa",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          borderRadius: "12px 12px 0px 0px",
          fontWeight: "bold",
          fontSize: "20px",
          padding: "8px",
        }}
      >
        <div>{getDayName(day.day.slice(0, 10))}</div>
        <div style={{ color: HOURS_COLOR }}>{getTotal(day.total)}</div>
      </div>
      <div style={{ padding: "8px" }}>
        {day.projects.map((project: HistoryProject) => (
          <div key={project.projectId}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 4px 2px 4px",
                fontWeight: 600,
                fontSize: "15px",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: project.color,
                  flexShrink: 0,
                }}
              />
              <span style={{ color: project.color }}>
                {project.projectName}
              </span>
              {project.clientName && (
                <span
                  style={{ color: "#888", fontWeight: 400, fontSize: "13px" }}
                >
                  — {project.clientName}
                </span>
              )}
              <span
                style={{
                  marginLeft: "auto",
                  color: HOURS_COLOR,
                  fontSize: "13px",
                }}
              >
                {getTotal(project.time)}
              </span>
            </div>
            {groupByDescription(project.sessions).map((group) => (
              <SessionGroup
                key={`${project.projectId}::${
                  group[0].description?.trim() ?? group[0].id
                }`}
                sessions={group}
                projectId={project.projectId}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
